import { ArrowLeft } from 'lucide-react';
import React from 'react';

interface BackLinkProps {
  onclick: () => void;
  label: string;
  subLabel?: string;
}

const BackLink = ({ label, onclick, subLabel }: BackLinkProps) => {
  return (
    <button
      type="button"
      className="cursor-pointer text-text-grey dark:text-white inline-flex gap-2 w-fit title1medium items-center"
      onClick={onclick}
    >
      <ArrowLeft color="#666666" className="dark:invert" />
      <span className="capitalize">{label}</span>
      {subLabel && <span className="capitalize title1bold ">{subLabel}</span>}
    </button>
  );
};

export default BackLink;
